import { Thematic, ProductCharacter, Promo } from './../store/modules/lib';
import Vue from 'vue';

import { Product as ProductType } from '@/store/modules/lib';

export class ServerProduct {

  public static list(exhibitorId: string): Promise<any> {

    return new Promise((resolve, reject) => {

      Vue.axios({
        url: '/query',
        method: 'POST',
        data: `
          {
            "query": "query {
              Products (_exhibitor : \\"${exhibitorId}\\") {
                count
                values {
                  characters {
                    title
                    description
                    value
                  }
                  _company
                  description
                  _event
                  _id
                  photo
                  promo {
                    id
                    type
                    value
                    order
                    title
                  }
                  _show
                  standTitle
                  thematic {
                    id
                    title
                    child {
                      title
                    }
                  }
                  title
                  vendorCode
                }
              }
            }"
          }
        `
      })
        .then((resp: any) => {
          resolve((resp.data.status == 'ok')
            ? resp.data.data.Products.values.filter((product: ProductType) => Object.keys(product).includes('title') && product.title != '')
            : []
          );
        })
        .catch((err: any) => {
          reject(err);
        });

    })

  }

  protected static stringifyThematic(th: Thematic) {

    return `{
      id: \\"${th.id}\\"
      child: []
      title: \\"${th.title}\\"
    }`;

  }

  protected static stringifyPromo(promo: Promo[]) {

    return '[' +
      promo
        .reduce((str: string[], promo: Promo) => {
          str.push(`{
            id: \\"${promo.id}\\"
            order: ${promo.order}
            type: \\"${promo.type}\\"
            title: \\"${this.replaceDoubleQuote(promo.title)}\\"
            value: \\"${this.replaceDoubleQuote(promo.value)}\\"
          }`);
          return str;
        }, [])
        .join(',') + ']';

  }

  protected static stringifyCharacters(characters: ProductCharacter[]) {

    return '[' +
      characters
        .reduce((str: string[], ch: ProductCharacter) => {
          str.push(`{
            description: \\"${ch.description}\\"
            title: \\"${this.replaceDoubleQuote(ch.title)}\\"
            value: \\"${this.replaceDoubleQuote(ch.value)}\\"
          }`);
          return str;
        }, [])
        .join(',') + ']';

  }

  protected static replaceDoubleQuote(str: string) {

    return str.replace(/\"/g, '”');

  }

  public static add(product: ProductType, _company: string): Promise<any> {

    return new Promise((resolve, reject) => {

      Vue.axios({
        url: '/query',
        method: 'POST',
        data: `
          {
            "query": "mutation {
              CreateDoc(
                model: \\"Product\\"
                pars:[
                  { key:\\"_company\\" value:\\"${ _company}\\" }
                ]
              ) {
                status
                _id
              }
            }"
          }
        `
      })
        .then((resp: any) => {

          if (resp.data.status == 'ok') {
            Vue.axios({
              url: '/query',
              method: 'POST',
              data: `
                {
                  "query": "mutation {
                    Product (
                        _id:\\"${resp.data.data.CreateDoc._id}\\"
                        title: \\"${ this.replaceDoubleQuote(product.title) }\\"
                        description: \\"${ this.replaceDoubleQuote(product.description) }\\"
                        photo: \\"${ product.photo }\\"
                        vendorCode: \\"${ this.replaceDoubleQuote(product.vendorCode) }\\"
                        thematic: ${ this.stringifyThematic(product.thematic)}
                        promo: ${ this.stringifyPromo(product.promo)}
                        characters: ${ this.stringifyCharacters(product.characters)}
                    ) {
                      characters {
                        title
                        description
                        value
                      }
                      _company
                      description
                      _event
                      _id
                      photo
                      promo {
                        id
                        type
                        value
                        order
                        title
                      }
                      _show
                      standTitle
                      thematic {
                        id
                        title
                        child {
                          title
                        }
                      }
                      title
                      vendorCode
                  }}"
                }
              `
            })
              .then((resp: any) => {

                if (resp.data.status == 'ok') {
                  resolve(resp.data.data.Product);
                }

              })
              .catch((err: any) => {
                reject(err);
              });
          }

        })
        .catch((err: any) => {
          reject(err);
        });

    })

  }

  public static remove(productId: string): Promise<any> {
    return new Promise((resolve, reject) => {

      Vue.axios({
        url: '/query',
        method: 'POST',
        data: `
          {
            "query": "mutation {
              RemoveDoc(
                remove: true
                model: \\"Product\\"
                _id: \\"${ productId }\\"
              ) {
                status
                _id
              }
            }"
          }
        `
      })
        .then((resp: any) => {
          resolve(resp.data.status == 'ok');
        })
        .catch((err: any) => {
          reject(false);
        });

    })

  }

  public static update(product: ProductType): Promise<any> {

    return new Promise((resolve, reject) => {

      Vue.axios({
        url: '/query',
        method: 'POST',
        data: `
              {
                "query": "mutation {
                  Product (
                      _id:\\"${product._id}\\"
                      title: \\"${ this.replaceDoubleQuote(product.title) }\\"
                      description: \\"${ this.replaceDoubleQuote(product.description) }\\"
                      photo: \\"${ product.photo }\\"
                      vendorCode: \\"${ this.replaceDoubleQuote(product.vendorCode) }\\"
                      thematic: ${ this.stringifyThematic(product.thematic)}
                      promo: ${ this.stringifyPromo(product.promo)}
                      characters: ${ this.stringifyCharacters(product.characters)}
                  ) {
                    characters {
                      title
                      description
                      value
                    }
                    _company
                    description
                    _event
                    _id
                    photo
                    promo {
                      id
                      type
                      value
                      order
                      title
                    }
                    _show
                    standTitle
                    thematic {
                      id
                      title
                      child {
                        title
                      }
                    }
                    title
                    vendorCode
                }}"
              }
            `
      })
        .then((resp: any) => {

          if (resp.data.status == 'ok') {
            resolve(resp.data.data.Product);
          }

        })
        .catch((err: any) => {
          reject(err);
        });


    })

  }
}

